import { Card, FormControl, FormHelperText, Grid2, IconButton, Slide, Tooltip } from '@mui/material';
import MaterialButton from '../../../../components/MaterialButton';
import MaterialInput from '../../../../components/MaterialInput';
import MaterialBox from '../../../../components/MaterialBox';
import MaterialTypography from '../../../../components/MaterialTypography';
import { Close, Send } from '@mui/icons-material';
import { useLoading } from '../../../../context/loading';
import { useContext, useEffect, useState } from 'react';
import BASEURL from '../../../Utils/Baseurl';
import Swal from "sweetalert2";
import UserDetailsContext from '../../../../context/auth';
import { useNavigate } from 'react-router-dom';
import { submitRegularizationMutation } from './regularizationData';


const RegularizationForm = ({ regularizationOpen, setRegularizationOpen,selectedDate}) => {
  
  const { setCirleLoading } = useLoading();
  const navigate = useNavigate();
  
  const { user } = useContext(UserDetailsContext);
  const [regularizationData, setRegularizationData] = useState({
    requestedDate: new Date().toISOString().split("T")[0],
    checkIn: selectedDate,
    checkOut: "",
    reason: "",
    checkInStatus: "unchecked",
    checkOutStatus: "unchecked",
    reasonStatus: "unchecked",
  });
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  useEffect(() => {
    if(regularizationOpen){
      setRegularizationData({
        requestedDate: new Date().toISOString().split("T")[0],
        checkIn: selectedDate || "",
        checkOut: "",
        reason: "",
        requesteddatestatus: "success",
        checkInStatus: "success",
        checkOutStatus: "unchecked",
        reasonStatus: "unchecked",
      })
    }
  },[regularizationOpen]);

  //Create Regularization
  const onRegularizationSubmit = async () => {
    setCirleLoading(true);
    const { checkIn, checkOut, reason } = regularizationData;

    try {
      const response = await fetch(BASEURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query: submitRegularizationMutation,
          variables: {
            input: {
              userId: user?.id,
              checkIn: formatForInput(checkIn),
              checkOut: checkOut,
              reason: reason,
              teamleaderId: +user?.teamleader,
              screenName: "Regularization Approval",
            },
          },
        }),
      });

      const data = await response.json();

      let Val = data.data.regularizationApprovalHR;

      if (Val !== null) {
        if (data.data.regularizationApprovalHR !== null && data?.data?.regularizationApproval?.success) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Regularization Submitted Successfully!",
            showConfirmButton: false,
            timer: 2500,
          });
          handleCloseRegularization();
        }
        else if(data?.data?.regularizationApproval?.success === false){
          Swal.fire({
            position: "center",
            icon: "error",
            title: data?.data?.regularizationApproval?.message,
            showConfirmButton: false,
            timer: 5000,
          });
        }
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setCirleLoading(false);
      } else if (Val == null) {
        if (
          data.errors[0]?.message ==
          "Your regularization request overlaps with an existing pending or approved leave request."
        ) {
          Swal.fire({
            position: "center",
            icon: "error",
            title: data.errors[0]?.message,
            showConfirmButton: false,
            timer: 5500,
          });
        }
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      }
      setCirleLoading(false);
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
    } catch (error) {
      console.error("responseError:", error);
      setCirleLoading(false);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  //Validation for Submit
  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      regularizationData.checkInStatus === "success" &&
      regularizationData.checkOutStatus === "success" &&
      regularizationData.reasonStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  //Handle Close Form Function
  const handleCloseRegularization = () => {
    setRegularizationOpen(false);
    setRegularizationData({
      ...regularizationData,
      requestedDate: new Date().toISOString().split("T")[0],
      checkIn: "",
      checkOut: "",
      reason: "",
      checkInStatus: "unchecked",
      checkOutStatus: "unchecked",
      reasonStatus: "unchecked",
    });
  };

  //Handle Change
  const handleAddRegularizationDatachange = (event) => {
    let regularizationState = { ...regularizationData };

    switch (event.target.name) {
      case "reason": {
        const descriptionRegex = new RegExp("^([\\s\\S]{10,100})$");

        if (descriptionRegex.test(event.target.value?.trim())) {
          regularizationState[event.target.name + "Status"] = "success";
        } else {
          regularizationState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }
      case "checkIn": {
        if (event.target.value?.trim()) {
          regularizationState[event.target.name + "Status"] = "success";
          regularizationState["checkOut"] = event.target.value;

          const dateOnly = event.target.value.split("T")[0];
        } else {
          regularizationState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }
      case "checkOut": {
        if (event.target.value?.trim()) {
          regularizationState[event.target.name + "Status"] = "success";
        } else {
          regularizationState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }
      default:
        break;
    }

    regularizationState[event.target.name] = event.target.value;

    setRegularizationData(regularizationState);
  };

// To convert date into the Check-in Field
const formatForInput = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if(dateString.length > 10){
  // Get local parts
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }
  else {
    return `${dateString}T09:30`;
  }
};
  

  return (
    <>
    {regularizationOpen && (
       <MaterialBox
            onClick={handleCloseRegularization}
            sx={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                bgcolor: "rgba(0, 0, 0, 0.59)",
                zIndex: 2,
            }}
        />
    )}
        <Slide
        timeout={1000}
        direction="right"
        in={regularizationOpen}
        mountOnEnter unmountOnExit>
          
          <MaterialBox 
          p={1}
          className="custom-dialog-box"
          open={regularizationOpen}
          onClose={(event, reason) => {
              if (reason !== 'backdropClick') handleCloseRegularization();
          }}>
            {/* Title */}
            <MaterialBox>
              <Grid2 container alignItems="center">
                  {/* Title Name*/}
                  <Grid2 size={{xs:10}} display="flex" justifyContent="center">
                    <MaterialTypography variant="h5" fontWeight="medium">
                      Regularization Form
                    </MaterialTypography>
                  </Grid2>
                  <Grid2 size={{xs:2}} display="flex" justifyContent="flex-end">
                      {/* Edit Icon to be implemented when View page exists*/}

                    {/* Close Icon */}
                    <Tooltip title="Close" disableInteractive enterDelay={1200}>
                      <IconButton onClick={handleCloseRegularization}>
                        <Close fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Grid2>
              </Grid2>
            </MaterialBox>
            {/* condition to check if regularization is applicalble */}
            {selectedDate > new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().slice(0,10) ?
            (
            <>
            <MaterialBox p={1}>
              <Grid2 container spacing={1}>
                  <Grid2 size={{ xs: 12, sm: 12 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Requested Date
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="requestedDate"
                      value={regularizationData.requestedDate}
                      readOnly
                      error={regularizationData.requesteddatestatus === "error"}
                      success={
                        regularizationData.requesteddatestatus === "success"
                      }
                    />
                  </Grid2>

                  <Grid2 size={{ xs: 12, sm: 12 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Check-In <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="checkIn"
                      type="datetime-local"
                      value={formatForInput(regularizationData.checkIn)}
                      onChange={handleAddRegularizationDatachange}
                      error={regularizationData.checkInStatus === "error"}
                      success={regularizationData.checkInStatus === "success"}
                      inputProps={{
                        min: new Date(
                          new Date().setDate(new Date().getDate() - 7)
                        ) // 7 days before today
                          .toISOString()
                          .slice(0, 16), // Format as YYYY-MM-DDTHH:mm
                      }}
                    />
                  </Grid2>

                  <Grid2 size={{ xs: 12, sm: 12 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Check-Out <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="checkOut"
                      type="datetime-local"
                      value={regularizationData.checkOut}
                      onChange={handleAddRegularizationDatachange}
                      error={regularizationData.checkOutStatus === "error"}
                      success={regularizationData.checkOutStatus === "success"}
                      inputProps={{
                        min: regularizationData.checkIn,
                      }}
                    />
                  </Grid2>

                  <Grid2 size={{ xs: 12, sm: 12 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Reason <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="reason"
                      // placeholder="eg. Reason"
                      value={regularizationData.reason}
                      onChange={handleAddRegularizationDatachange}
                      error={regularizationData.reasonStatus === "error"}
                      success={regularizationData.reasonStatus === "success"}
                      multiline
                      rows={4}
                    />
                    {regularizationData.reasonStatus === "error" && (
                      <FormControl error>
                        <FormHelperText>
                          Reason should be a minimum 10 characters maximum 100
                          characters long.
                        </FormHelperText>
                      </FormControl>
                    )}
                  </Grid2>
              </Grid2>
            </MaterialBox>
             {/* Form Action */}
              <MaterialBox
              display="flex"
              justifyContent="flex-end"
              alignItems="center">
                {/* Delete button to be implemented when View page exists */}

                  <MaterialButton
                    sx={{m:2, marginLeft: "4px"}}
                    variant="gradient"
                    color="dark"
                    size="small"
                    endIcon={<Send />}
                    disabled={                    
                      !checkAllFields()
                    }
                    onClick={onRegularizationSubmit}
                  >
                    Apply
                  </MaterialButton>
              </MaterialBox>
            </>
            ) :
            // Error without date configuration
            (
            <>
              <Card variant="outlined" raised style={{ padding: "12px", borderRadius: "10px", margin: "10px" , textAlign: "center" }}>
                <MaterialTypography  variant="body2" color="error">
                  Regularization cannot be applied on {new Date(selectedDate).toDateString()}.
                </MaterialTypography>
              </Card>                           
            </>
            )
            }
          </MaterialBox>
        </Slide>
    </>
  )
}

export default RegularizationForm